import { MdOutlineClose } from "react-icons/md";
import Button from "../buttons/button";
import TransParentButton from "../TransparentButton.js/TransParentButton";
import { RiDeleteBin6Line } from "react-icons/ri";
import ReactQuill from "react-quill";
import warningIcon from "../../../assets/warning.png";

const ActionPopup = ({
  onClose,
  inputValue,
  heading,
  imageUrl = "/right.png",
  showInput = false,
  inputPlaceholder = "Enter details...",
  handleInputValue,
  handleConfirm,
  showActionPopup,
  statusHeading,
  inputError,
  handleImageUpload,
  showImage = false,
  image,
  handleRemoveImage,
  isNote, noteValue, noteChange, showRequestStep = false, optionsRequestSteps = [], stepOptionPlaceHolder = "Select Option",
  selectedRequestOption, onChangeSelectedOption = () => null
}) => {


  return (
    <>
      {showActionPopup && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto">
            <div
              className="bg-white p-6 rounded-[19px] shadow-lg text-center lg:w-[30rem] w-11/12 mx-auto max-h-[90vh] flex flex-col my-auto"
              style={{ maxHeight: '90vh' }}
            >
              <div className='flex items-center justify-between mb-4 flex-shrink-0'>
                <p className='text-lg font-bold text-black capitalize'>{statusHeading}</p>
                <div className='bg-[#15A14A26] rounded-full flex justify-center items-center h-7 w-7 text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
                  <MdOutlineClose
                    size={20}
                    className=' cursor-pointer'
                    onClick={onClose}
                    title='Close'
                  />
                </div>
              </div>
              <div
                className="space-y-3 overflow-y-auto flex-1 pr-1 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-full text-center"
                style={{ overflowY: 'auto', minHeight: 0 }}
              >
                <div className="flex items-center justify-center mb-4">
                  <img
                    src={imageUrl === "/warning.png" ? warningIcon : imageUrl}
                    alt=""
                    className="w-20 h-20 object-contain"
                  />
                </div>
                <p className="text-[17px] font-[600] text-black mb-4">{heading}</p>
                {showInput && (
                  <>
                    <input
                      type="text"
                      value={inputValue}
                      onChange={(e) => handleInputValue(e.target.value)}
                      placeholder={inputPlaceholder}
                      className={`w-full p-2 mb-4 border rounded outline-none ring-1 
                    ${inputError?.inputValue ? 'border-red-500 ring-red-500' : 'border-gray-300 ring-green-500'}`}
                    />
                    {inputError?.inputValue && (
                      <p className='text-sm text-red-500'>{inputError?.inputValue}</p>
                    )}
                  </>
                )}

                {showRequestStep && (
                  <>
                    <select className={`w-full p-2 mb-4 border rounded outline-none ring-1 
                    ${inputError?.requestOptionError ? 'border-red-500 ring-red-500' : 'border-gray-300 ring-green-500'}`}
                      value={selectedRequestOption}
                      onChange={onChangeSelectedOption}
                    >
                      {stepOptionPlaceHolder && (
                        <option value="" disabled>
                          {stepOptionPlaceHolder}
                        </option>
                      )}
                      {optionsRequestSteps?.map((option) => (
                        <option key={option?.value} value={option?.value}>
                          {option?.label}
                        </option>
                      ))}

                    </select>
                    {inputError?.requestOptionError && (
                      <p className='text-sm text-red-500'>{inputError?.requestOptionError}</p>
                    )}
                  </>
                )}
                {isNote && (
                  <div className="mb-4 text-left">
                    <ReactQuill
                      theme="snow"
                      value={noteValue}
                      onChange={noteChange}
                      className="bg-white"
                    />
                    {inputError?.inputValue && (
                      <p className="text-sm text-red-500">{inputError?.inputValue}</p>
                    )}
                  </div>
                )}
                {statusHeading === "approved" && (
                  <div className="mb-4">
                    {showImage && (
                      <div className="bg-white p-4 sm:p-6 rounded-md border border-[#dbd9d9] text-center">
                        <label
                          htmlFor="image-upload"
                          className="flex items-center justify-center p-4 mb-4 border-2 border-gray-300 border-dashed rounded-md cursor-pointer hover:border-green-500 hover:bg-gray-50 transition-colors"
                        >
                          <span className="font-semibold text-gray-500">Click to upload an image</span>
                          <input
                            type="file"
                            accept="image/*"
                            id="image-upload"
                            className="hidden"
                            onChange={handleImageUpload}
                          />
                        </label>

                        {image ? (
                          <div
                            className="relative mb-4 flex items-center justify-center bg-gray-50 rounded-md border border-gray-200 p-2 overflow-hidden"
                            style={{ maxHeight: '270px', minHeight: '120px' }}
                          >
                            <button
                              onClick={handleRemoveImage}
                              type="button"
                              className="absolute p-2 text-[#ee6666] transition duration-300 bg-black/80 hover:bg-black rounded-full top-2 right-2 z-10 shadow"
                              title="Remove Image">
                              <RiDeleteBin6Line size={20} />
                            </button>
                            <img
                              src={image}
                              alt="Uploaded Preview"
                              className="rounded-md mx-auto"
                              style={{
                                maxHeight: '250px',
                                maxWidth: '100%',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block'
                              }}
                            />
                          </div>
                        ) : (
                          <p className="text-gray-400">No image selected</p>
                        )}
                      </div>
                    )}
                    {inputError?.attachment && (
                      <p className='text-sm text-red-500'>{inputError?.attachment}</p>
                    )}
                  </div>
                )}
              </div>

              {/* Action buttons pinned at bottom */}
              <div className="flex justify-center gap-4 pt-4 border-t border-gray-100 flex-shrink-0">
                <TransParentButton onClick={onClose}>Cancel</TransParentButton>
                <Button
                  onClick={handleConfirm}
                  isDisable={!!inputError?.inputValue || (inputValue && inputValue.trim().length === 0)}>
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ActionPopup;

